export interface IUserState {
  userId: number | null;
}

const initialState: IUserState = {
  userId: null,
};

export function userReducer(state: IUserState = initialState) {
  return state;
}
